<template>
  <!--基本信息-->
  <div class="informationbg">
    <div class="info-text">
      <img
        class="info-img"
        src="../../assets/images/activity/workshop/imformation.png"
      />
    </div>
    <div class="info-content">
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="info-icon"></div>
          <span>修理厂类型</span>
          <van-radio-group v-model="workshopType" direction="horizontal">
            <van-radio name="01" shape="square" icon-size="14px"
              >维修</van-radio
            >
            <van-radio name="02" shape="square" icon-size="14px"
              >保养</van-radio
            >
            <van-radio name="03" shape="square" icon-size="14px"
              >专修</van-radio
            >
          </van-radio-group>
        </div>
      </div>
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="info-icon"></div>
          <span>工位数量</span>
          <van-field v-model="stationQty" type="digit" center />
        </div>
      </div>
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="info-icon"></div>
          <span>是否连锁</span>
          <van-radio-group v-model="isChain" direction="horizontal">
            <van-radio name="1" shape="square" icon-size="14px">是</van-radio>
            <van-radio name="0" shape="square" icon-size="14px">否</van-radio>
          </van-radio-group>
        </div>
      </div>
      <div class="input-row">
        <div class="info-name icon-user">
          <div class="info-icon"></div>
          <span>你希望用以下哪种方式浏览易加商城？</span>
          <van-radio-group v-model="accessType" direction="horizontal">
            <van-radio name="01" shape="square" icon-size="14px"
              >公众号</van-radio
            >
            <van-radio name="02" shape="square" icon-size="14px"
              >小程序</van-radio
            >
            <van-radio name="03" shape="square" icon-size="14px"
              >无所谓</van-radio
            >
          </van-radio-group>
        </div>
      </div>
    </div>
    <div class="submit-btn">
      <van-button
        :loading="loading"
        type="info"
        size="normal"
        @click="handleSubmit"
        ><img
          class="imgbtn"
          src="../../assets/images/activity/workshop/submit.png"
      /></van-button>
    </div>
  </div>
</template>

<script>
import activityApi from '@/api/activity'
export default {
  name: 'ActivityWorkshopCollectInformation',
  data () {
    return {
      loading: false,
      workshopType: '', // 修理厂类型
      stationQty: '', // 工位数量
      isChain: '', // 是否连锁
      accessType: '' // 浏览方式
    }
  },
  methods: {
    showErroMsg (msg) {
      this.$toast({
        type: 'fail',
        duration: 1000,
        message: msg
      })
    },
    handleSubmit () {
      // const checkInput = new RegExp('^[1-9][0-9]*$').test(this.stationQty)
      // 检查是否有未填项
      if (!this.workshopType) {
        this.showErroMsg('请选择修理厂类型')
        return false
      }
      if (!this.stationQty) {
        this.showErroMsg('请填写工位数量')
        return false
      }
      if (!new RegExp('^[1-9][0-9]*$').test(this.stationQty)) {
        this.showErroMsg('工位数量请输入整数')
        this.stationQty = ''
        return false
      }
      if (!this.isChain) {
        this.showErroMsg('请选择是否连锁')
        return false
      }
      if (!this.accessType) {
        this.showErroMsg('请选择浏览方式')
        return false
      }

      // 要提交的参数（修理厂类型， 工位数量， 是否连锁）
      const params = {
        workshopType: this.workshopType, // 修理厂类型
        stationQty: parseInt(this.stationQty), // 工位数量
        isChain: parseInt(this.isChain), // 是否连锁
        accessType: this.accessType // 浏览方式
      }
      this.$toast.loading({
        message: '信息提交中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      activityApi
        .workshopCollectTask1Submit(params)
        .then((response) => {
          this.$toast.clear()
          if (response.data.resultCode === '0') {
            // 提交成功后跳转到活动主页面
            this.$router.back()
            // this.$router.push('/activity/activity-workshop-collect')
          } else {
            this.showErroMsg(response.data.resultMsg)
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="less" scoped>
.informationbg {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/activity/workshop/mainbg.png");
  background-size: 100% 100%;
  background-repeat: repeat-y;
  .info-text {
    padding: 50px 128px 20px 128px;
    .info-img {
      width: 118px;
      height: 29px;
    }
  }
  .info-content {
    width: 90%;
    height: 350px;
    margin: 0 auto;
    border-radius: 10px;
    background-color: rgb(250, 250, 250);
  }
  .input-row {
    position: relative;
    height: 80px;
    // margin-bottom: 10px;
    .info-name {
      position: absolute;
      top: 15px;
    }
    .icon-user {
      left: 16px;
      right: 16px;
      .info-icon {
        width: 9px;
        height: 20px;
        background-color: rgb(227, 106, 91);
        border-radius: 50px;
        display: inline-block;
        margin-right: 8px;
      }
    }
  }
}
.van-field {
  width: 220px;
  height: 30px;
  background-color: rgb(250, 250, 250);
  border: 1px rgb(214, 210, 210) solid;
  margin: 17px;
}
.van-radio-group--horizontal {
  margin: 17px;
}
.van-radio--horizontal {
  margin-right: 20px;
}
.submit-btn {
  margin: 20px 5px;
  text-align: center;
  .van-button {
    width: 343px;
    height: 50px;
    line-height: 50px;
    background: rgb(227, 106, 91);
    border: none;
    border-radius: 8px;
    .imgbtn {
      width: 43px;
      height: 19px;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto auto;
    }
  }
}
</style>
